
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.225 2.553A.999.999 0 018.119 2h3.762c.378 0 .725.214.894.553L13 3h3a1 1 0 110 2H4a1 1 0 010-2h3l.225-.447zM3.972 6H16v10c0 1.103-.897 2-2 2H5.972c-1.077 0-2-.897-2-2V6zm2.5 2.5v7c0 .275.253.5.5.5.303 0 .5-.225.5-.5v-7c0-.275-.197-.5-.5-.5a.52.52 0 00-.5.5zm3 0v7c0 .275.253.5.5.5.303 0 .528-.225.528-.5v-7c0-.275-.225-.5-.528-.5a.52.52 0 00-.5.5zm3.028 0v7c0 .275.225.5.5.5s.5-.225.5-.5v-7c0-.275-.225-.5-.5-.5s-.5.225-.5.5z","fill":"#999"}})])
          )
        }
      }
    